// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"114":"4a9d410a","252":"69b0bc24","257":"0cc93609","821":"4a9d410a"}[chunkId] + ".chunk.css";
};